// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"b0924388","113":"d2848f2b","142":"75049773","234":"ab13b871","538":"ec7d9448","648":"76315988","656":"5a02b99a"}[chunkId] + ".chunk.js";
};